export const toggleTaskList = (key, value, setTaskForm) => {
    setTaskForm((prev) => {
        const list = new Set(prev[key]);
        if (list.has(value)) {
            list.delete(value);
        } else {
            list.add(value);
        }
        return { ...prev, [key]: Array.from(list) };
    });
};
